<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Label, Input, Tabs, TabItem } from "flowbite-svelte";
  import TipTapEditor from "$lib/admin/components/content/TipTapEditor/TipTapEditor.svelte";
  import type { IntroProps } from "@/src/types/components/Intro";
  import ImageSelector from "$lib/admin/components/media/ImageSelector.svelte";
  import { getBucketLink } from "$lib/common/helpers/image";

  export let props: IntroProps;

  const IMG_CONTENT_FOLDER = getBucketLink() + "media/";
  const dispatch = createEventDispatcher();
</script>

<div class="space-y-6 p-4 bg-white rounded-lg shadow">
  <div>
    <Label for="header" class="mb-2 text-lg font-medium">Heading</Label>
    <Input id="header" bind:value={props.header} placeholder="Write an H1" on:keyup size="lg" class="w-full" />
  </div>

  <Tabs style="underline" class="mt-6">
    <TabItem open title="Introduction">
      <div class="p-4">
        <TipTapEditor placeholder="Introduction" bind:text={props.content} on:keyup />
      </div>
    </TabItem>
    <TabItem title="Image">
      <div class="p-4">
        <ImageSelector
          imagePath={props.image?.url || ""}
          imageUrl={props.image?.url ? IMG_CONTENT_FOLDER + props.image?.url : ""}
          bucketName="content"
          on:change={() => dispatch("keyup")}
          on:select={(event) => {
            const filePath = event.detail.filePath.replace("cf/images/media/", "");
            props.image = {
              ...(props.image || {}),
              url: filePath
            };
            dispatch("keyup");
          }}
          on:delete={() => {
            props.image = undefined;
            dispatch("keyup");
          }}
          folderPath="cf/images/media/"
          height="250px"
          width="100%"
          placeholderText="Select an image"
          buttonText="Select Image" />
      </div>
    </TabItem>
  </Tabs>
</div>
